import { AccountInfo } from '../types/account.info';
import { UserToken } from '../types/user.token';
import { Requests } from '../types/auth.requests';
import { AccountNotification } from '../types/account.notification';

export class AuthStoreState {
  isLoggedIn = false;
  redirectUrl = '/';
  accountInfo: AccountInfo = null;
  accountNotifications: AccountNotification = {
    size: 5,
    page: 1,
    notifications: [],
    total: 0,
    totalUnread: 0,
    unread: false,
  };
  token: UserToken = {
    expirationDate: null,
    accessToken: null,
    refreshToken: null,
  };
  requests: Requests = {
    getAccountNotifications: {},
    getAccountInfo: {},
    requestForToken: {},
    refreshToken: {},
    updateLocale: {},
    requestForgottenPassword: {},
    getAccountNotificationsStats: {},
    clearUnreadNotifications: {},
  };
  sessionId: null;
  isAdminUser = false;
  isEmployeeUser = false;
  isAfterLogin: boolean;
  mawdyTheme: any;

  constructor() {
    this.isAfterLogin = false;
  }
}
